var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#003D76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3933 17.0573C29.3933 23.9021 23.8447 29.4507 16.9999 29.4507C10.1551 29.4507 4.60645 23.9021 4.60645 17.0573C4.60645 10.2125 10.1551 4.66382 16.9999 4.66382C23.8447 4.66382 29.3933 10.2125 29.3933 17.0573Z",
    fill: "#003D76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6982 23.0819C15.3095 23.0819 14.9188 22.9589 14.5896 22.7074L9.44495 17.4751C8.65059 16.8687 8.50328 15.7396 9.11609 14.9534C9.7287 14.1673 10.8694 14.0215 11.6638 14.6279L15.4778 18.8445L21.7539 11.9695C22.4265 11.2328 23.575 11.1751 24.3195 11.841C25.0638 12.5065 25.122 13.6435 24.4493 14.3802L17.0467 22.4893C16.6897 22.8803 16.1956 23.0819 15.6982 23.0819Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.896a5207969e1d0784a50c65e8b62e29.svg";
export { ForwardRef as ReactComponent };